<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>
                    {{ $t("TRUCK_BRAND") }}
                    <v-spacer></v-spacer>
                    <v-menu offset-y absolute="">
                        <template v-slot:activator="{on}">
                            <v-btn
                                :disabled="loading.data"
                                small
                                fab
                                v-on="on"
                                color="primary">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense width="200">
                            <v-list-item
                                @click="openTruckModelDialog({editMode: false, truck_brand_id: truckBrand.id})">
                                <v-list-item-title link>{{ $t("ADD_MODEL") }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-card-title>
                <v-card-text>
                    <div class="text-center" v-if="loading.data">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-row v-if="!loading.data">
                        <v-col v-if="truckBrand">
                            <v-simple-table>
                                <tbody>
                                    <tr>
                                        <th>{{ $t('BRAND_NAME') }}</th>
                                        <td>{{ truckBrand.name }} </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-data-table
                        dense
                        v-if="!loading.data"
                        hide-default-footer
                        :items="truckModels"
                        :headers="headers.truckModel">
                            <template v-slot:item.actions="{ item }">
                            <v-menu>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                        icon
                                        small
                                        v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-list dense width="200">
                                        <v-list-item
                                            v-if="authorizations.truck_models.update"
                                            link
                                            :disabled="!item.meta.editable"
                                            @click="openTruckModelDialog({editMode: true, truck_brand_id: truckBrand.id, id: item.id})">
                                            <v-list-item-avatar>
                                                <v-icon :disabled="!item.meta.editable">mdi-pencil</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item
                                            link
                                            :disabled="!item.meta.deletable"
                                            v-if="authorizations.truck_models.delete"
                                            @click="openTruckModelDeleteDialog({id: item.id})">
                                            <v-list-item-avatar>
                                                <v-icon :disabled="!item.meta.deletable">mdi-delete</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ $t('ACTIONS_MENU_DELETE') }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="close()"
                        class="mx-1">
                        {{ $t('BTN_CLOSE') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <TruckModelDialog 
            ref="truckModelDialog"/>
        <RetryDialog
            ref="retryDailog"
            @submit="onSubmitRetryDailog"/>
        <DeleteDialog
            ref="deleteDialog"
            @submit="onSubmitDeleteDialog"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
import { mapActions,mapState } from 'vuex';
import TruckModelDialog from "../components/TruckModelDialog";
import RetryDialog from "../components/RetryDialog";
import DeleteDialog from '../components/DeleteDialog';
import AlertDialog from '../components/AlertDialog';
export default {
    components:{
        TruckModelDialog,
        RetryDialog,
        DeleteDialog,
        AlertDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            headers: {
                truckModel: [
                    {text: this.$t('MODEL_NAME'), value: "name"},
                    {text: this.$t('GROUP_NAME'), value: "group"},
                    {text: this.$t('ACTIONS_MENU_TITLE'), value: "actions"}
                ]
            },
            loading: {
                data: false
            }
        }
    },
     computed: {
        ...mapState("truckBrand", ["truckBrand"]),
        ...mapState("truckModel",["truckModels"]),
        ...mapState("authentication", ["authorizations"])
    },
    methods: { 
        ...mapActions("truckBrand",["fetchTruckBrand"]),
        ...mapActions("truckModel",["fetchTruckModels", "removeTruckModel"]),
        openTruckModelDialog(params){
            this.$refs.truckModelDialog.open(params);
        },
        open(params) {
            this.loading.data = true;
            this.openParams =params;
            this.display = true;
            this.openDataFetch(this.openParams);
        },
        async openDataFetch(params){
            try {
                await this.fetchTruckBrand(params.id);
                await this.fetchTruckModels({truck_brand_id: params.id});
                this.loading.data = false;
            } catch(error){
                let message = null;
                if(error.response) message = error.response.data.message;
                else message = error;
                this.$refs.retryDialog.open({target:'openDataFetch',message})
            }
        },
        onSubmitRetryDailog(params) {
            if(params.target == "openDataFetch") {
                if(params.retry == true) this.openDataFetch(this.openParams);
                else this.close();
            }
        },
        close() {
            this.display = false;
        },
        openTruckModelDeleteDialog(params) {
            this.$refs.deleteDialog.open({target: "TRUCK_MODEL", id: params.id});
        },
        onSubmitDeleteDialog(params) {
            if(params.target == "TRUCK_MODEL") {
                this.removeTruckModel(params.id)
                    .then(() => {
                        this.$refs.deleteDialog.close();
                        this.fetchTruckModels({truck_brand_id: this.openParams.id});
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), this.$t("RECORD_DELETE_SUCCESS"))
                    })
                    .catch(error => {
                        let message = null;
                        if(error.response) message = error.response.data.message;
                        else error = message;
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
                    });
            }
        }
    }

}
</script>